<template>
  <team-inbox-alert-modal-wrapper
    :visible="visible"
    :modal-title="modalTitle"
    @close="handleClose"
  >
    <div class="modal-content-inner">
      <team-inbox-alert-header :user-count="users.length" />
      
      <team-inbox-alert-search
        :search-query.sync="searchQuery"
        :filtered-count="filteredUsers.length"
        :total-count="users.length"
      />
      
      <team-inbox-alert-table
        :users="filteredUsers"
        :search-query="searchQuery"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
      />
    </div>
  </team-inbox-alert-modal-wrapper>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TeamInboxAlertModalWrapper from './team-inbox-alert-modal-wrapper.vue'
import TeamInboxAlertHeader from './team-inbox-alert-header.vue'
import TeamInboxAlertSearch from './team-inbox-alert-search.vue'
import TeamInboxAlertTable from './team-inbox-alert-table.vue'

export default {
  name: 'TeamInboxAlertModal',

  components: {
    TeamInboxAlertModalWrapper,
    TeamInboxAlertHeader,
    TeamInboxAlertSearch,
    TeamInboxAlertTable
  },

  data() {
    return {
      searchQuery: '',
      currentPage: 1,
      pageSize: 10
    }
  },

  computed: {
    ...mapState('teamInbox', {
      visible: 'teamInboxAlertVisible',
      users: 'usersWithoutTeamInboxAccess'
    }),

    modalTitle() {
      return 'Users Without Team Inbox Access'
    },

    filteredUsers() {
      if (!this.searchQuery.trim()) {
        return this.users
      }

      const query = this.searchQuery.toLowerCase()
      return this.users.filter(user => {
        const fullName = `${user.first_name} ${user.last_name}`.toLowerCase()
        const email = (user.email || '').toLowerCase()
        return fullName.includes(query) || email.includes(query)
      })
    }
  },

  watch: {
    filteredUsers() {
      // Reset to first page when search results change
      this.currentPage = 1
    }
  },

  methods: {
    ...mapActions('teamInbox', ['hideTeamInboxAlert']),

    handleClose() {
      this.hideTeamInboxAlert()
      this.searchQuery = ''
      this.currentPage = 1
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>

